import { useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function usePedidoPolling(pedidoId, pedidoIdRef, sessionId, schemaName) {
  const [estadoPedido, setEstadoPedido] = useState(null);
  const socketUpdatedAtRef = useRef(0);
  const pollSkipMs = 5000;

  const markSocketUpdated = useCallback(() => {
    socketUpdatedAtRef.current = Date.now();
  }, []);

  const fetchEstadoPedido = useCallback(
    async (pid) => {
      if (Date.now() - socketUpdatedAtRef.current < pollSkipMs) return;
      try {
        const res = await axios.get(`${API_URL}/pedidos/${pid}?schema_name=${schemaName}&session_id=${sessionId}`);
        if (res.data.status === 'success') {
          setEstadoPedido(res.data.data.estado);
        }
      } catch {}
    },
    [schemaName, sessionId]
  );

  useEffect(() => {
    if (!pedidoId || !sessionId) return;
    fetchEstadoPedido(pedidoId);
    const interval = setInterval(() => {
      if (!pedidoIdRef.current) {
        clearInterval(interval);
        return;
      }
      fetchEstadoPedido(pedidoIdRef.current);
    }, 15000);
    return () => clearInterval(interval);
  }, [pedidoId, sessionId, fetchEstadoPedido, pedidoIdRef]);

  return { estadoPedido, setEstadoPedido, fetchEstadoPedido, markSocketUpdated };
}
